module.exports = __webpack_public_path__ + "static/media/AWS_black.c501783f.png";